export class GetUserContentAnnotationsDto {
  constructor(public contentId: number | string, public contentType: number) {}
}
